/**
 * The six designation buckets, shared by the constellation chart and the
 * scheduled-research panel. Keyed on the EXACT strings in
 * vals_framework.designation_category, listed in the same hierarchy order the
 * API returns them in.
 * Source of truth: Linkam_backend/app/utils/designation_categories.py
 *
 * Five hues from the dataviz reference palette, validated as a set for a
 * scatter (all pairs): CVD ΔE >= 9.1, normal-vision >= 15.6. The darker hues
 * go to the upper ranks. Aqua and amber sit under 3:1 on white, so the sidebar
 * labels and the list beside the chart carry identity too.
 */
export const DESIGNATION_COLORS: Record<string, string> = {
  'Founder & Co-Founder': '#4a3aa7',
  'Executive Leadership (C-Suite)': '#2a78d6',
  'Senior Management': '#008300',
  'Mid-Level & Individual Contributor': '#1baf7a',
  'Academic & Research': '#eda100',
  'Other / Unclassified': '#94a3b8',
};

/** Sidebar labels; the full category names are too long for a filter row. */
export const DESIGNATION_SHORT: Record<string, string> = {
  'Founder & Co-Founder': 'Founder',
  'Executive Leadership (C-Suite)': 'C-Suite',
  'Senior Management': 'Senior Mgmt',
  'Mid-Level & Individual Contributor': 'Mid-Level & IC',
  'Academic & Research': 'Academic',
  'Other / Unclassified': 'Other',
};
